import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  AppBar,
  Avatar,
  Box,
  IconButton,
  ListItemIcon,
  Menu,
  MenuItem,
  Toolbar,
  Tooltip,
  Typography,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import Brightness4Icon from "@mui/icons-material/Brightness4";
import Brightness7Icon from "@mui/icons-material/Brightness7";
import LogoutIcon from "@mui/icons-material/Logout";
import avatar from "../../assets/img/avatar.png";
import { getSessionData, removeSessionData } from "../../utils/storageUtils";
import { Notificacoes } from "../Notificacoes";
import { PERFIL_PAINEL_TV } from "../../types/PermissaoInterface";
import { useTema } from "../../contexts/TemaContext";

interface BarraSuperiorProps {
  // Largura ocupada pelo menu lateral fixo (0 em telas pequenas)
  larguraMenu: number;
  onAlternarMenu: () => void;
}

// Barra superior da área logada (mesmo padrão do XC WMS)
const BarraSuperior = ({ larguraMenu, onAlternarMenu }: BarraSuperiorProps) => {
  const navigate = useNavigate();
  const { modo, alternarModo } = useTema();
  const usuario = getSessionData("NomeUsuario") || "";
  const avatarUsuario = getSessionData("DadosAvatarClinica") || "";
  const perfilTv = getSessionData("PerfilUsuario") === PERFIL_PAINEL_TV;
  const [anchorUsuario, setAnchorUsuario] = useState<HTMLElement | null>(null);

  useEffect(() => {
    if (usuario === "") {
      navigate("/login");
    }
  });

  const logoff = () => {
    removeSessionData("xc-helpdesk-token");
    removeSessionData("DadosUsuario");
    removeSessionData("EmailUsuario");
    removeSessionData("DadosUsuarioID");
    removeSessionData("PerfilUsuario");
    removeSessionData("isPerfilSuper");
    removeSessionData("NomeUsuario");
    navigate("/login");
  };

  const escuro = modo === "escuro";
  const corConteudo = escuro ? "#F6F6F7" : "#28243D";

  return (
    <AppBar
      position="fixed"
      elevation={0}
      sx={{
        width: `calc(100% - ${larguraMenu}px)`,
        ml: `${larguraMenu}px`,
        transition: "width 0.3s, margin-left 0.3s",
        backgroundColor: escuro ? "#28243D" : "#F6F6F7",
        backgroundImage: "none",
        color: corConteudo,
        boxShadow: "none",
        // Abaixo do menu lateral e dos modais react-bootstrap
        zIndex: 1030,
      }}
    >
      <Toolbar>
        <IconButton
          edge="start"
          onClick={onAlternarMenu}
          aria-label="Abrir ou fechar o menu"
          sx={{ mr: 2, color: "inherit" }}
        >
          <MenuIcon />
        </IconButton>
        <Box sx={{ flexGrow: 1 }} />

        <Tooltip title={escuro ? "Modo claro" : "Modo escuro"}>
          <IconButton onClick={alternarModo} sx={{ color: "inherit" }}>
            {escuro ? <Brightness7Icon /> : <Brightness4Icon />}
          </IconButton>
        </Tooltip>

        {!perfilTv && (
          <>
            <Notificacoes />
            <IconButton
              onClick={(e) => setAnchorUsuario(e.currentTarget)}
              sx={{ color: "inherit", borderRadius: 2 }}
            >
              <Avatar
                src={avatarUsuario ? `data:image/png;base64,${avatarUsuario}` : avatar}
                alt={usuario}
                sx={{ width: 36, height: 36, border: `2px solid ${corConteudo}` }}
              />
              <Typography
                variant="body1"
                noWrap
                sx={{ ml: 1, display: { xs: "none", sm: "block" } }}
              >
                {usuario}
              </Typography>
            </IconButton>
            <Menu
              anchorEl={anchorUsuario}
              open={Boolean(anchorUsuario)}
              onClose={() => setAnchorUsuario(null)}
              anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
              transformOrigin={{ vertical: "top", horizontal: "right" }}
            >
              <MenuItem onClick={logoff} sx={{ color: "error.main" }}>
                <ListItemIcon>
                  <LogoutIcon fontSize="small" color="error" />
                </ListItemIcon>
                Sair
              </MenuItem>
            </Menu>
          </>
        )}
      </Toolbar>
    </AppBar>
  );
};

export default BarraSuperior;
